import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import Navigation from './Navigation';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeToggle from './ThemeToggle';
import './Header.css';

const Header = () => {
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const logoPath = theme === 'dark' 
    ? '/eevn_logo_dark.png' 
    : '/eevn_logo_light.png';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-container" onClick={scrollToTop}>
          <img src={logoPath} alt="eevn" className="logo" />
        </div>
        
        <Navigation isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        
        <div className="header-controls">
          <LanguageSwitcher />
          <ThemeToggle />
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

